import FormSingleSelect from 'src/components/Control/FormControls/FormSingleSelect';
import { FORM_ID } from 'src/models/FormModel';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import { t } from 'src/lib/language';

interface Props {
  disabled?: boolean,
  form: FORM_ID,
  name: string,
  onChange: (id:Nullable<number>) => void,
  value?: string | '',
}

interface Item {
  id: string,
  display: any,
}

const LocaleSelector = (props: Props) => {
  const {
    disabled, form, name, onChange, value,
  } = props;
  const languages = ['en_CA', 'fr_CA', 'en_US'];

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  function formatLocale(input: string): string {
    if (!input) return '';
    const [language, region] = input.split('_');
    const display = t(lang, `misc.${language}`);
    // @ts-ignore
    return (<span>{display} <i>({region.toLowerCase()})</i></span>);
  }

  const getItems = () => languages.map((item: any) => ({
    id: item,
    display: formatLocale(item),
  } as Item));

  const normalizeValue = (id:number) => {
    let normalValue: Nullable<number> = id;
    if (!normalValue) {
      normalValue = null;
    }
    onChange(normalValue);
  };

  return (
    <FormSingleSelect
      id="locale-selector"
      disabled={disabled}
      form={form}
      items={getItems()}
      label="Locale"
      name={name}
      onChange={normalizeValue}
      value={value || ''}
      noMarginTop />
  );
};

export default LocaleSelector;
